import React, { PureComponent, PropTypes } from 'react';
import { createStyleSheet } from 'jss-theme-reactor';
import {
  ListItem,
  ListItemIcon,
  ListItemText
} from '@catalytic/pushbot-ui/List';
import ProcessOutline from '@catalytic/pushbot-ui/SvgIcon/ProcessOutline';

export const styleSheet = createStyleSheet(
  'UserWatchListProcessItem',
  theme => ({
    primary: {
      fontWeight: theme.typography.fontWeightHeavy
    }
  })
);

export default class UserWatchListProcessItem extends PureComponent {
  static displayName = 'UserWatchListProcessItem';

  static propTypes = {
    /**
     * Class to apply to the list items in the filter list
     */
    className: PropTypes.string,
    /**
     * Location of search page for more items when a user clicks on this item
     */
    href: PropTypes.string,
    /**
     * Click event to apply to the list items in the filter list
     */
    onClick: PropTypes.func,
    /**
     * Name of the process that is to be displayed for the item
     */
    processDisplayName: PropTypes.string
  };

  static contextTypes = {
    styleManager: PropTypes.object.isRequired
  };

  render() {
    const { className, href, onClick, processDisplayName } = this.props;
    const classes = this.context.styleManager.render(styleSheet);

    return (
      <ListItem {...{ className, href, onClick }}>
        <ListItemIcon>
          <ProcessOutline />
        </ListItemIcon>
        <ListItemText
          inherit
          noWrap
          primary={processDisplayName}
          primaryClassName={classes.primary}
        />
      </ListItem>
    );
  }
}



// WEBPACK FOOTER //
// ./js/UserWatchList/UserWatchListProcessItem.js